import { z } from "zod";

export const RequestWatcherTypeSchema = z.enum([
  "NO_WATCHERS",
  "DEPARTMENT_APPROVERS",
  "BUSINESS_UNIT_APPROVERS",
  "CUSTOM_WATCHERS",
]);

export type RequestWatcherType = z.infer<typeof RequestWatcherTypeSchema>;
